<div class="main-conatainer">
  <h1>Copy or Move Lesson</h1>
  <p *ngIf="isCourse">
   Are you sure you want to <b>{{actionTypeRadio}}</b> this <b>lesson plan to another semester</b>?
  </p>
  <p *ngIf="!isCourse">
    A lesson can only be moved/copied if semester class type is same.
   </p>
  <ion-radio-group *ngIf="isCourse" value="move" [disabled]="isLoading" [(ngModel)]="actionTypeRadio" class="radio-btn">
    <ion-radio value="move" labelPlacement="end">Move</ion-radio><br />
    <ion-radio value="copy" labelPlacement="end">Copy</ion-radio>
  </ion-radio-group>

  <ion-list class="list" *ngIf="isCourse">
    <ion-item>
      <ion-select
        [(ngModel)]="selectedCourse"
        aria-label="semester"
        placeholder="Choose Semester"
        interface="popover"
      >
        <ion-select-option text-wrap *ngFor="let course of courses" [value]="course">
          <!-- <ion-label class="ion-text-wrap"> -->
            <div>{{getCourseTitle(course)}}</div><br/>
            <div>{{getCourseSubDetails(course)}}</div>
          <!-- </ion-label> -->
        </ion-select-option>
      </ion-select>
    </ion-item>
  </ion-list>
  <div class="buttons">
    <button class="cancel" [disabled]="isLoading" (click)="onCancel()">
      Cancel
    </button>
    <button *ngIf="isCourse" class="submit" [disabled]="isLoading || !selectedCourse" (click)="onMoveCopyConfirmationPopupModal()">
      {{actionTypeRadio|titlecase}}
    </button>
    <button *ngIf="!isCourse" class="submit" (click)="onCancel()">
     Ok
    </button>
  </div>
</div>
